import { render, staticRenderFns } from "./microTip.vue?vue&type=template&id=f1ba3570&scoped=true"
import script from "./microTip.vue?vue&type=script&lang=js"
export * from "./microTip.vue?vue&type=script&lang=js"
import style0 from "./microTip.vue?vue&type=style&index=0&id=f1ba3570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ba3570",
  null
  
)

export default component.exports